import { render, staticRenderFns } from "./TextAreaCustomConfigView.vue?vue&type=template&id=24c87d88&scoped=true&"
import script from "./TextAreaCustomConfigView.vue?vue&type=script&lang=js&"
export * from "./TextAreaCustomConfigView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c87d88",
  null
  
)

export default component.exports